import React, { useState } from 'react'
import { View } from 'react-native'
import { tv } from 'tailwind-variants'

import { SubGroupAccordion } from '@flows-ui/components/quote/SubGroupAccordion'
import type { ProductExtension } from '@flows/index'

const familyCoverageStyles = tv({
  slots: {
    container: 'gap-y-4 pb-4',
  },
})

const FAMILY_COVERAGE_EXTENSION_KEY = 'family_coverage'

export const LiabilityFamilyCoverageInfoAccordions = ({
  extensions = [],
}: {
  extensions?: ProductExtension[]
}) => {
  const [expandedItem, setExpandedItem] = useState<string | null>(null)
  const { container } = familyCoverageStyles()

  const familyExtension = extensions.find(
    (extension) => extension.configurationDataExtensionKey === FAMILY_COVERAGE_EXTENSION_KEY
  )

  if (!familyExtension) {
    return null
  }

  return (
    <View className={container()}>
      {familyExtension.contentSubGroups?.map((subGroup) => (
        <SubGroupAccordion
          key={subGroup.itemKey?.current ?? subGroup.title}
          subGroup={subGroup}
          expandedItem={expandedItem}
          onToggleItem={setExpandedItem}
          defaultExpanded
        />
      ))}
    </View>
  )
}
